import styled, { css } from 'styled-components'

import { TransitionPrimary } from '@/lib/mixins'

export const FieldTogglerWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

export const FieldTogglerLabel = styled.label`
  display: flex;
  font-size: 1.2rem;
  font-weight: 500;
  cursor: pointer;

  span {
    padding-top: 0.5rem;
  }
`

interface FieldTogglerIndicatorProps {
  active?: boolean
}

export const FieldTogglerIndicator = styled.div<FieldTogglerIndicatorProps>`
  flex-shrink: 0;
  width: 4rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${props => props.theme.color.primary};
  border-radius: 2rem;
  margin-right: 0.5rem;
  ${TransitionPrimary('border, background-color')}

  &:before {
    width: 2rem;
    height: 2rem;
    content: '';
    position: absolute;
    top: 0.25rem;
    left: 0.25rem;
    border-radius: 50%;
    background-color: ${props => props.theme.color.primaryMedium};
    ${TransitionPrimary('transform, background-color')}
  }

  ${props =>
    props.theme.contrastMode &&
    css`
      border-color: ${props => props.theme.color.global};
    `};

  ${props =>
    props.active &&
    css`
      background-color: ${props => props.theme.color.primary};

      &:before {
        background-color: ${props => props.theme.color.body};
        transform: translateX(1.5rem);
      }
      ${props =>
        props.theme.contrastMode &&
        css`
          background-color: ${props => props.theme.color.global};
          svg {
            fill: ${props => props.theme.color.dark};
          }
        `};
    `};
`

export const FieldTogglerInput = styled.input`
  display: none;
`
